module.exports = fabric;


//////////////////
// WEBPACK FOOTER
// external "fabric"
// module id = 994
// module chunks = 385